var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#70797B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3499 9.64992V2.35943C14.2019 2.55442 17.4453 5.80046 17.6404 9.64992H10.3499ZM18.8459 10.2678C18.9943 5.28332 14.7206 1.00543 9.73205 1.1539C9.40778 1.16355 9.1499 1.42921 9.1499 1.75363V10.2499C9.1499 10.5813 9.41853 10.8499 9.7499 10.8499H18.2462C18.5706 10.8499 18.8363 10.592 18.8459 10.2678ZM6.29123 3.30727C6.58092 3.14637 6.68532 2.7811 6.52443 2.49141C6.36353 2.20173 5.99826 2.09732 5.70857 2.25822C2.99108 3.76757 1.1499 6.66831 1.1499 9.9999C1.1499 14.8876 5.11218 18.8499 9.9999 18.8499C13.3315 18.8499 16.2322 17.0087 17.7416 14.2913C17.9025 14.0016 17.7981 13.6363 17.5084 13.4754C17.2187 13.3145 16.8534 13.4189 16.6925 13.7086C15.3862 16.0605 12.8783 17.6499 9.9999 17.6499C5.77492 17.6499 2.3499 14.2249 2.3499 9.9999C2.3499 7.12153 3.93932 4.61357 6.29123 3.30727Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics);
export default __webpack_public_path__ + "static/media/icon-analytics.7b60231a6d39059929951476afb756da.svg";
export { ForwardRef as ReactComponent };